export default [
    {
        path: 'mapa-atendimento',
        component: () => import(/* webpackChunkName: 'atencao-basica-mapa-atendimento' */ '@/views/atencao-basica/mapa-atendimento/Index'),
        redirect: 'mapa-atendimento/index',
        children: [
            {
                name: 'atencao-basica-mapa-atendimento-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'atencao-basica-mapa-atendimento' */ '@/views/atencao-basica/mapa-atendimento/List.vue'),
            },
        ],
    },
]